import { useQuery } from '@tanstack/react-query';
import { TypePaymentOption } from '../../../@types/generated';
import { Currency } from '../../types/PaymentTypes';
import { getAmountSuggestions } from '../api/paymentRequests';

const AMOUNT_SUGGESTIONS = 'AMOUNT_SUGGESTIONS';

export function useAmountSuggestions({
  currency,
  amountConfiguration,
}: {
  currency?: Currency;
  amountConfiguration?:
    | TypePaymentOption['fields']['oneTimeAmountConfiguration']
    | TypePaymentOption['fields']['subscriptionAmountConfiguration'];
}) {
  const { isPending: isLoadingAmountSuggestions, data } = useQuery({
    queryKey: [AMOUNT_SUGGESTIONS, [amountConfiguration, currency]],

    queryFn: async () => {
      const { result } = await getAmountSuggestions({
        currencyCode: (currency as Currency).code,
        configuration: amountConfiguration,
      });

      return {
        amountSuggestions: result.map((amountSuggestion) => amountSuggestion.amount),
        defaultAmountSuggestion: result.find((amountSuggestion) => amountSuggestion.default)
          ?.amount,
      };
    },

    enabled: Boolean(currency?.code),
  });

  return { ...data, isLoadingAmountSuggestions };
}
